import { useId } from 'react';

type LogoMarkProps = {
  size?: number;
  className?: string;
};

/** The КСЕНУС ГИС icon mark — seven ribbed vertical bars clipped to an X silhouette.
 * useId() keeps the clip mask unique so multiple instances can render on one page. */
export function LogoMark({ size = 24, className = '' }: LogoMarkProps) {
  const maskId = useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="5" y="4" width="48" height="50">
        <path
          d="M5.35376 4.46143H14.723L28.9999 22.7537L43.2768 4.46143H52.6461V13.3845L34.3538 28.9999L52.6461 44.6153V53.5384H43.2768L28.9999 35.246L14.723 53.5384H5.35376V44.6153L23.6461 28.9999L5.35376 13.3845V4.46143Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${maskId})`} className="fill-brand">
        <path d="M10.2615 4.01514H5.35376V53.9844H10.2615V4.01514Z" />
        <path d="M17.1767 4.01514H12.269V53.9844H17.1767V4.01514Z" />
        <path d="M24.0923 4.01514H19.1846V53.9844H24.0923V4.01514Z" />
        <path d="M31.8999 4.01514H26.0999V53.9844H31.8999V4.01514Z" />
        <path d="M38.8154 4.01514H33.9077V53.9844H38.8154V4.01514Z" />
        <path d="M45.7307 4.01514H40.823V53.9844H45.7307V4.01514Z" />
        <path d="M52.646 4.01514H47.7383V53.9844H52.646V4.01514Z" />
      </g>
    </svg>
  );
}
